import { type EvidenceDetail, getApiEvidenceV1EvidenceSessionRetrieveQueryKey, useQueryClient } from 'api';
import React from 'react';
import { Dialog, DialogActions, DialogCloseButton, DialogContent, DialogTitle, Stack, Typography } from 'ui';

import { EvidenceEditForm } from '../EvidenceEditForm/EvidenceEditForm';
import { EvidenceGrid } from '../EvidenceGrid/EvidenceGrid';

export interface Props {
  open: boolean;
  onClose: () => void;
  date: string;
  uploadedById: number | null;
  parentContentTypeId: number;
  parentId: number;
}

export const SessionEvidenceEditDialog = ({
  onClose,
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
  open,
}: Props) => {
  const queryClient = useQueryClient();
  const [selectedEvidenceIds, setSelectedEvidenceIds] = React.useState<EvidenceDetail['id'][]>([]);

  const handleClose = () => {
    setSelectedEvidenceIds([]);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>Step 1. Select the evidence you want to modify</DialogTitle>
      <DialogCloseButton onClick={handleClose} />
      <DialogContent>
        <EvidenceGrid
          setSelectedEvidenceIds={setSelectedEvidenceIds}
          date={date}
          parentContentTypeId={parentContentTypeId}
          parentId={parentId}
          uploadedById={uploadedById}
        />
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
        }}
      >
        <Stack direction="column" width="100%">
          <Typography variant="h6">Step 2. Specify how to modify the selected evidence</Typography>
          <EvidenceEditForm
            selectedEvidenceIds={selectedEvidenceIds}
            onSuccess={() => {
              queryClient.invalidateQueries({
                queryKey: getApiEvidenceV1EvidenceSessionRetrieveQueryKey({
                  date,
                  parent_content_type_id: parentContentTypeId,
                  parent_id: parentId,
                  uploaded_by: uploadedById,
                }),
              });

              onClose();
            }}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
